module.exports = __webpack_public_path__ + "static/media/customer-6.9b3f0c44.jpg";